const LOCALE_KEY = 'X-LAS-Locale';

export const getUserLocale = () => {
    return localStorage.getItem(LOCALE_KEY);
};

export const persistUserLocale = (locale) => {
    return localStorage.setItem(LOCALE_KEY, locale);
};
